import React from 'react';
import { Typography } from '@mui/material';
import classes from './Header.module.scss';

const Header = () => {
  return (
    <div className={classes.container}>
      <Typography className={classes.title}>Subscription details</Typography>
    </div>
  );
};

export { Header };
